import { useRouter } from 'next/router'

export const useGray = () => {
  const router = useRouter()
  const c_time = new Date().getTime()
  const start_time = new Date('2022/12/01').getTime()
  const end_time = new Date('2022/12/07 20:00:00').getTime()

  return {
    /** 黑白屏 */
    isGray:
      c_time >= start_time && c_time < end_time && router.pathname === '/',
  }
}
